// @flow
import focusContract from './CentralizeHouseContract'
import DateRange from './DateRange'
import API from './api'

const Divider = {
  template: `<div style="border-bottom:1px solid #cecece; width: 610px; margin-bottom: 22px;"></div>`,
}

const CoSpan = {
  template:
    `<span style="width:13px; text-align:left; display: inline-block; margin-left: -3px;">` +
    `<slot></slot></slot></span>`,
}

const requiredRule = [
  { required: true, message: '此项不能为空', trigger: 'blur' },
]
const phoneRule = [
  { required: true, message: '此项不能为空', trigger: 'blur' },
  { min: 11, max: 13, message: '请输入正确的手机号格式', trigger: 'blur' },
]
const requiredNumberRule = [
  { required: true, type: 'number', message: '请输入数字', trigger: 'blur' },
]
const requiredDateRule = [
  { required: true, type: 'date', message: '此项不能为空', trigger: 'blur' },
]
const requiredArrayRule = [
  { required: true, type: 'array', message: '此项不能为空', trigger: 'blur' },
]

const rules = {
  userName: requiredRule,
  userPhone: phoneRule,
  certificateType: requiredRule,
  certificateNum: requiredRule,
  bankName: requiredRule,
  bankOfAccounts: requiredRule,
  bankAccount: requiredRule,
  payeeName: requiredRule,
  blockName: requiredRule,
  roomNo: requiredRule,

  zoneData: requiredArrayRule,
  decorateType: requiredRule,
  floorHeight: requiredNumberRule,
  rentType: requiredRule,
  houseSpaceManagerArea1: requiredRule,
  currentFloor: requiredNumberRule,
  houseCertificateType: requiredRule,
  houseOwnershipCertificateNumber: requiredRule,

  startTime: requiredDateRule,

  rental1: requiredNumberRule,
  deposit1: requiredRule,
  cycle: requiredRule,
  paperNum: requiredRule,
  signTime: requiredDateRule,
  housekeeper: requiredArrayRule,
}

const form = {
  userName: '',
  userPhone: null,
  certificateType: 'ID', // 房东证件类型
  certificateNum: '',
  bankName: '',
  bankOfAccounts: '',
  bankAccount: '',
  payeeName: '',
  blockName: '',
  buildingNo: '',
  unitNo: '',
  roomNo: '',

  zoneData: [],
  decorateType: 'R',
  floorHeight: '',
  rentType: '',
  houseSpaceManagerArea1: '',
  currentFloor: '',
  houseCertificateType: 'OFFICIAL', // 房屋证件类型
  houseOwnershipCertificateNumber: '', // 房产证号

  startTime: new Date(),

  rental1: '',
  deposit1: '',
  cycle: '',
  paperNum: '',
  signTime: new Date(),
  housekeeper: [],

  // ==== 后来郭启龙要上传的字段

  houseType: 'DISTRIBUTE', // (('DISTRIBUTE', '分散式'), ('CENTRALIZE', '集中式'))
  contractType: 'DELEGATE',

  // ====

  deposit: 0, // 押金
  payWay: '1',
  during: '',
  payCycle: 'ONEMON', // 支付周期
  addType: 'NOTRISE', // 租金递增方式
  addCycle: 'NORISE', // 租金递增周期
  payMethod: 'CYCLE',
  conType: '1', // 合同分类
  housekeeperName: '', // 小管家姓名
  housekeeperPhone: '', // 小管家联系方式
  bedroomNumber: '1',
  livingRoomNumber: '1',
  toiletNumber: '1',
  kitchenNumber: '0',
  direction: 'EAST',
  zoneId: '',
  zone: '',
  insuranceStatus: 'YES',
  penalty: '',
  penalty1: '',
  freeStyle: '0',
  year: 0,
  month: 0,
  day: 0,
  freeMonth: 0,
  freeDay: 0,
  decorationStyle: null,
  decorationMonth: 0,
  decorationDay: 0,

  province: '',
  city: '',
  district: '',
  reqChargInputLogBeanList: [],
}

const max = {
  bedroomNumber: 6,
  livingRoomNumber: 6,
  kitchenNumber: 7,
  toiletNumber: 6,
  floorHeight: 40,
  currentFloor: 40,
  year: 20,
  month: 12,
  day: 31,
  freeMonth: 11,
  freeDay: 31,
  decorationMonth: 11,
  decorationDay: 32,
}

export default {
  props: {
    // 新签 or 续签
    signType: {
      type: String,
      default: 'NEW',
    },
    context: Object,
    contractId: [String, Number],
    formLabelWidth: {
      type: String,
      default: '120px',
    },
    disable: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    Divider,
    CoSpan,
    focusContract,
    DateRange,
  },

  data() {
    const initForm = () => {
      const mixin = {
        loginId: this.getUid(),
        enterId: this.getUid(),
        signType: this.signType, // ('NEW', 'RENEWAL')
      }
      if (this.context) {
        const PARTA = this.context.users.find(u => u.representative === 'PARTA')
        if (PARTA) {
          return {
            ...form,
            ...PARTA,
            certificateNum: PARTA.certificateNumber,
            payeeName: this.context.payeeName,
            houseSpaceId: this.context.houseSpaceId,
            zoneId: this.context.unitId, // zoneId will be set to unitId then post
            unitId: this.context.unitId,
            originalContractId: this.contractId ? this.contractId : undefined,
            startTime: new Date(this.context.endTime + 3600 * 1000 * 24),
            ...mixin,
          }
        }
      }

      return {
        ...form,
        ...mixin,
      }
    }

    const getNumOptions = max => {
      let obj = {}
      for (let k in max) {
        obj[k] = Array(max[k])
          .fill(null)
          .map((_, i) => i)
      }
      return obj
    }

    return {
      form: initForm(),

      rules,

      numOptions: getNumOptions(max),

      options: {
        // 管家
        houseKeeper: JSON.parse(this.$store.state.currentUser.houseData),
        bankName: [],
        bankOfAccounts: [],
        province: [],
        city: [],
        district: [],
      },

      // 费用列表
      reqChargInputLogBeanList: [
        {
          startChargTime: '',
          endChargTime: '',
          initialAmount: '',
          advanceDays: null,
        },
      ],

      provincePickerShowing: false,
      // 是否创建DateRange
      dateRangeShowing: false,
      // 提交后隐藏
      dateRangeSubmited: false,

      houseType: 'DISTRIBUTE',
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        },
      },

      props: {
        value: 'label',
        children: 'cities',
      },
      unitProps: {
        value: 'text',
        children: 'children',
      },
      addShdow: false,

      landlordList: [],
      restaurants: [],
      restaurants1: [
        // 小区
      ],
      userInfo: {
        bean: 2,
      },
      bankSearch: this.$store.state.searchUrl + 'baseDataInfo', // 查询银行
      repList: [],
      addTypeShow: false, // 控制自定义递增规则弹窗
      addType: 'NOTRISE',
      width: 'width: 75px;',
      effectTime: '',
      endTime: '',
      unit: [], // 片区列表

      addWay: [
        // 不规则递增方式
        {
          time: '',
          getPrice: '',
          addAmount: '',
          addPer: '',
          addAmount1: '',
          addPer1: '',
          rentFreeEnd: '',
          rentFreeStart: '',
        },
      ],

      unitList: [], // 片区列表
      clickOver: true, // 判断提交结束与否
      timer: null, // 计时器
      bankMessageList: [], // 银行信息列表
    }
  },

  computed: {
    showDateRangeAble() {
      return (
        this.form.startTime &&
        this.form.endTime &&
        this.form.cycle &&
        this.form.rental1
      )
    },
    reqChargInputLogBeanListOk() {
      return (
        this.form.reqChargInputLogBeanList &&
        this.form.reqChargInputLogBeanList.length
      )
    },
    distributeShowing() {
      let { context } = this
      return !context || (context && context.houseType === 'DISTRIBUTE')
    },

    centralizeShowing() {
      let { context } = this
      const reCentralize = context && context.houseType === 'CENTRALIZE'
      if (reCentralize) {
        this.houseType = 'CENTRALIZE'
      }
      return !context || reCentralize
    },
  },

  created() {
    const bindFunction = () => {
      for (let k in API) {
        if (typeof API[k] === 'function') {
          API[k] = API[k].bind(this)
        }
      }
    }

    bindFunction()

    const repSearch = () => {
      this.$http
        .post(this.urljoin(this.urlList.account, 'user/list'), {
          userType: 'M',
        })
        .then(res => {
          let data = res.data.data.list
          let option = []
          for (var i = 0; i < data.length; i++) {
            if (data[i].username) {
              option.push({
                id: data[i].id,
                phone: data[i].phone,
                sex: data[i].sex,
                value: data[i].username,
              })
            }
          }
          this.repList = option
        })
    }

    repSearch()

    this.setHouseFormDefaultKeeper()

    const loadBankNameOptions = () => {
      this.$http
        .post(this.bankSearch, { baseDataType: 'FIRST_LEVEL_BANK_INFO' })
        .then(res => {
          if (res.body.code === 200) {
            this.options.bankName = res.body.data
            let req = {
              baseDataType: 'SECOND_LEVEL_BANK_INFO',
              bankName: res.body.data[0].bankName,
            }
            this.$http.post(this.bankSearch, req).then(res => {
              if (res.body.code === 200) {
                this.options.bankOfAccounts = res.body.data
              }
            })
          }
        })
    }
    loadBankNameOptions()

    const unitSelect = () => {
      this.unitList = []
      this.$http
        .get(this.urljoin(this.urlList.account, 'unit/tree/f/area'))
        .then(({ data }) => {
          var data1 = data.data.children
          this.unitFormat(data.data.children)
          this.unit = data1
          // this.form.zoneData[0] = this.unit[0].text
          // console.log('开始及执行')
          // this.form.zone = this.unit[0].text
          // this.form.zoneId = this.unit[0].id
        })
    }

    unitSelect()

    this.loadOptions()

    // console.log(this.form)
  },
  watch: {
    // 所在楼层响应总楼层
    'form.floorHeight'(val: number, oldVal: number) {
      this.numOptions.currentFloor = Array(val)
        .fill(null)
        .map((_, i) => i)
    },

    'form.decorationMonth'() {
      this.form.vacancyPeriod = `${this.form.decorationMonth}月${this.form.decorationDay}日`
    },
    'form.decorationDay'() {
      this.form.vacancyPeriod = `${this.form.decorationMonth}月${this.form.decorationDay}日`
    },
  },

  methods: {
    // 重置账单信息
    handlePropChanged() {
      // v-if
      this.dateRangeShowing = false
      // v-show
      this.dateRangeSubmited = false
      if (
        this.form.reqChargInputLogBeanList &&
        this.form.reqChargInputLogBeanList.length
      ) {
        this.$message.warning('账单信息已被空置。')
        this.form.reqChargInputLogBeanList = []
      }
    },

    // 选择空置期类型
    selectDecorationStyle(value) {
      if (!value) {
        this.form.decorationMonth = 0
        this.form.decorationDay = 0
      }
    },

    // DateRange提交
    handleDateRangeSubmit(reqChargInputLogBeanList: Array<Object>) {
      this.form.reqChargInputLogBeanList = reqChargInputLogBeanList
      this.dateRangeSubmited = true
    },

    showDateRange() {
      if (!this.dateRangeShowing) {
        this.dateRangeShowing = true
        this.dateRangeSubmited = false
      } else {
        this.dateRangeSubmited = false
      }
    },

    loadOptions() {
      API.fetchProvinces().then(res => {
        if (res.data.code === 200) {
          this.options.province = res.data.data
        }
      })
    },

    // 选择银行
    changeBank(value: string) {
      let req = {
        baseDataType: 'SECOND_LEVEL_BANK_INFO',
        bankName: value,
      }
      this.$http.post(this.bankSearch, req).then(res => {
        if (res.body.code === 200) {
          const data = res.body.data
          if (data && data.length) {
            this.options.bankOfAccounts = data
          }
        }
      })
    },

    // 检索银行支行
    searchBank(queryString: string, cb: Function) {
      if (queryString) {
        cb(
          this.options.bankOfAccounts.filter(
            bank => bank.branchBankName.indexOf(queryString) > -1
          )
        )
      }
    },

    // 检索小区信息
    searchBlockName(queryString: string, cb: Function) {
      this.restaurants1 = []
      if (queryString) {
        let req = {}
        req.baseDataType = 'BLOCK_INFO'
        req.blockName = queryString
        this.$http.post(this.bankSearch, req).then(res => {
          if (res.body.code === 200) {
            let len = 0
            if (res.body.data.length > 10) {
              len = 10
            } else {
              len = res.body.data.length
            }
            for (let i = 0; i < len; i++) {
              let list = {}
              list.value = res.body.data[i].blockName
              list.district = res.body.data[i].district
              list.province = res.body.data[i].province
              list.city = res.body.data[i].city
              list.pid = res.body.data[i].pid
              this.restaurants1.push(list)
            }
          }
        })
      }
      var restaurants = this.restaurants1
      cb(restaurants)
    },

    // 房东联系方式失焦
    checkUser() {
      let phone = this.form.userPhone
      let name = this.form.userName
      let certificateNum = this.form.certificateNum
      // 如果 姓名、电话、和身份证号都已填写，则发送请求
      if (name && phone && certificateNum) {
        this.$http
          .get(this.urljoin(this.urlList.account, 'user/info/p/', phone))
          .then(res => {
            // 通过手机号获取id
            if (res.body.code === 200) {
              // 通过id获取到详细信息
              this.$http
                .get(
                  this.urljoin(
                    this.urlList.account,
                    'user/info/cert/',
                    res.body.data.id
                  )
                )
                .then(resId => {
                  if (resId.body.code === 200) {
                    var data = resId.body.data
                    // console.log(data.certNumber)
                    if (
                      name !== data.username ||
                      phone !== data.phone ||
                      certificateNum !== data.certNumber
                    ) {
                      this.$message({
                        message: '用户信息与系统信息不匹配，请核对后重新输入',
                        type: 'error',
                      })
                    }
                  }
                })
            }
          })
      }
    },

    // 选择房东姓名
    selectUserName(item: Object) {
      // console.log(item)
      this.form = {
        ...this.form,
        userPhone: item.phone,
        userId: item.id,
        sex: item.sex,
      }

      this.$http
        .get(this.urljoin(this.urlList.account, 'user/info/cert', item.id))
        .then(({ data }) => {
          if (data.code === 200) {
            this.form.certificateType = data.data.certType
            this.form.certificateNum = data.data.certNumber // 通过名字搜索，并点击搜索结果触发selecteUserName事件后，form将更新并同步到页面输入框，同时赋值给userInfo.

            this.userInfo.name = this.form.userName
            this.userInfo.phone = item.phone
            this.userInfo.certificateNum = data.data.certNumber // 将请求到的用户身份证号赋值给 userInfo
            this.userInfo.bean = 2
            this.userInfo.bool = 1
          } else if (data.code === 10000) {
            this.userInfo.certificateNum = ''
            this.userInfo.bean = 3
            this.userInfo.bool = 3
          }
        })
    },

    // 检索房东姓名
    queryUser(queryString: string, cb: Function) {
      var dataList = {}
      dataList.username = queryString
      // 搜索房东
      this.landlordList = []
      this.$http
        .post(this.urljoin(this.urlList.account, 'user/list'), dataList)
        .then(({ data }) => {
          var option = []
          if (data.code === 200) {
            var data1 = data.data.list
            for (let i = 0; i < data1.length; i++) {
              // 如果根据名字返回为空
              if (
                data1[i].username === '' ||
                data1[i].username === null ||
                typeof data1[i].username === 'undefined'
              ) {
              } else {
                // 如果根据名字，返回不为空
                option.push({
                  id: data1[i].id,
                  phone: data1[i].phone,
                  sex: data1[i].sex,
                  value: data1[i].username,
                })
              }
            }
          } else {
            option = []
          }
          this.landlordList = option
          var restaurants = this.landlordList
          var results = restaurants
          var result = []
          for (let i = 0; i < results.length && i < 10; i++) {
            result[i] = results[i]
          }
          // 调用 callback 返回建议列表的数据
          cb(result)
        })
    },
    // 根据输入内容检索银行信息
    queryBankMessage(queryString, cb) {
      var time = 1000 // 设置延时时长
      this.bankMessageList = [] // 清空银行信息列表
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.$http
          .get(this.urljoin(this.urlList.search, 'searchBankName', queryString))
          .then(res => {
            if (res.data.code === 200) {
              res.data.data.forEach(item => {
                var bankObj = {}
                bankObj.value = item.bankName
                this.bankMessageList.push(bankObj)
              })
            }
          })
        cb(this.bankMessageList) // 回调显示
      }, time)
    },
    // 选择已有银行信息
    selectBankName(item) {
      this.form.bankName = item.value
    },
    // 响应日期选择
    chooseEndTime() {
      let { startTime, year, month, day } = this.form
      // eslint-disable-next-line
      this.form.endTime =
        year == 0 && month == 0 && day == 0
          ? null
          : new Date(
              this.moment(startTime)
                .add(year, 'years')
                .add(month, 'months')
                .add(day - 1, 'days')
                .valueOf()
            )
    },

    // 设置小管家更多信息默认值
    setHouseFormDefaultKeeper() {
      this.$http
        .get(this.urljoin(this.urlList.account, 'user/info/id/', this.getUid()))
        .then(res => {
          if (res.data.code === 200) {
            let { id, username, phone } = res.data.data
            this.form.housekeeper = [localStorage.getItem('role'), username]
            this.form.housekeeperName = username
            this.form.housekeeperPhone = phone
            this.form.housekeeperId = id
          }
        })
    },

    // 移除费用表单
    removePay(index: number) {
      this.reqChargInputLogBeanList.splice(index, 1)
    },

    // 添加费用表单
    addPay() {
      this.reqChargInputLogBeanList.push({
        startChargTime: '',
        endChargTime: '',
        initialAmount: '',
        advanceDays: null,
      })
    },

    // 小管家id
    changeHouseKeeper(val) {
      var results = val[0]
        ? this.options.houseKeeper.filter(this.keeperFilter(val[0]))
        : this.options.houseKeeper
      for (var k = 0; k <= results[0].cities.length - 1; k++) {
        if (val[1] === results[0].cities[k].label) {
          this.form.housekeeperId = results[0].cities[k].id
          this.form.housekeeperPhone = results[0].cities[k].phone
        }
      }
    },
    keeperFilter(queryString) {
      // 房东信息
      return restaurant => {
        return restaurant.label.indexOf(queryString.toLowerCase()) === 0
      }
    },
    closeForm() {
      this.$emit('listenToParentEvent')
    },

    validate530NewAdd() {
      let find = this.form.reqChargInputLogBeanList.find(o => {
        // 允许费用金额及收费提前天数为0
        return !Object.values(o).every(item => {
          return parseInt(item) === 0 || item
        })
      })

      if (find) {
        this.$message.error('计费规则不能为空。')
        return false
      }

      return true
    },

    beforePost() {
      const reqChargInputLogBeanList = this.form.reqChargInputLogBeanList.map(
        o => ({
          ...o,
          chargType: 'REN',
          cycle: this.form.cycle,
          financeType: 'PAY',
        })
      )

      return {
        rentalFreeStart: this.moment().format('YYYY-MM-DDT00:00:00'),
        rentalFreeEnd: this.moment().format('YYYY-MM-DDT00:00:00'),
        waterMeterReading: this.form.waterMeterNumber1 * 1000,
        electricMeterReading: this.form.electricMeterNumber1 * 1000,
        gasMeterReading: this.form.gasMeterNumber1 * 1000,
        deposit: parseInt(this.form.deposit1) * 1000,
        rental: parseInt(this.form.rental1) * 1000,
        penalty: 0,
        addAmount: this.form.addAmount1 * 1000,
        addPer: this.form.addPer1 * 1000,
        housekeeperName: this.form.housekeeper[1],
        unitId: this.form.unitId || this.form.zoneId, // unitId required
        housePrice: this.form.rental1 * 1000,
        reqChargInputLogBeanList,
      }
    },

    submitForm() {
      console.log(this.form)
      this.$refs['form'].validate(valid => {
        if (!valid) {
          this.$message.warning('您的表单信息填写有误，请核对并纠正。')
        } else {
          // const reqChargInputLogBeanList = () => {
          //   this.form.reqChargInputLogBeanList = this.reqChargInputLogBeanList.map(item => ({
          //     startChargTime: this.moment(item.startChargTime).format('YYYY-MM-DDT00:00:00'),
          //     endChargTime: this.moment(item.endChargTime).format('YYYY-MM-DDT00:00:00'),
          //     initialAmount: item.initialAmount === '' ? '' : Number(item.initialAmount) * 1000, // 空字符串不转换
          //     advanceDays: item.advanceDays || 0
          //   }))
          // }

          // reqChargInputLogBeanList()

          // if (!this.validate530NewAdd()) return

          if (this.context) {
            API.postDelegateForm(
              {
                ...this.form,
                ...this.beforePost(),
              },
              res => {
                console.log('tryfix806', res)
                this.$message({
                  message: '新建合同成功',
                  type: 'success',
                })
                this.$emit('addTrusteeshopSuccess', false)
              },
              res => {
                console.log('tryfix824', res)
                this.$message({
                  message:
                    res.body.message || `后端未知错误。[${res.body.code}]`,
                  type: 'error',
                })
                this.clickOver = true
              }
            )
            return
          }
          this.clickOver = false
          if (!this.form.city) {
            this.provincePickerShowing = true
            this.clickOver = true
          } else {
            // 城市已经存在的情况下 分两种 一种是新建之后的 另外一种是选择之后获取的
            let formData = Object.assign({}, this.form)
            if (!isNaN(this.form.province)) {
              formData.province = this.options.province.filter(
                item => item.provinceId === this.form.province
              )[0].province
              formData.city = this.options.city.filter(
                item => item.cityId === this.form.city
              )[0].city
              formData.district = this.options.district.filter(
                item => item.areaId === this.form.district
              )[0].area
            }
            API.postBlock(formData, res => {
              this.form = {
                ...this.form,
                blockId: res.body.data.pid,
                ...this.beforePost(),
              }
              let formDataCopy = Object.assign({}, this.form)
              if (!isNaN(this.form.province)) {
                formDataCopy.province = this.options.province.filter(
                  item => item.provinceId === this.form.province
                )[0].province
                formDataCopy.city = this.options.city.filter(
                  item => item.cityId === this.form.city
                )[0].city
                formDataCopy.district = this.options.district.filter(
                  item => item.areaId === this.form.district
                )[0].area
              }
              API.postHouseForm(
                formDataCopy,
                res => {
                  if (res.body.code === 200) {
                    this.form.houseSpaceId = res.body.data
                  } else if (res.body.code === 10002) {
                    // 数据重复
                    // 和阿国协商，临时用用message get下houseSpaceId
                    this.form.houseSpaceId = res.body.message
                    this.clickOver = true
                  }
                  API.postDelegateForm(
                    this.form,
                    res => {
                      this.$message({
                        message: '新建合同成功',
                        type: 'success',
                      })
                      this.$emit('addTrusteeshopSuccess', false)
                    },
                    res => {
                      console.log('tryfixp01', res)
                      if (res.data.code === 10001) {
                        this.$message({
                          message: '该房源已经签订过房东合同，请不要重复签订',
                          type: 'error',
                        })
                        this.clickOver = true
                      } else {
                        this.$message({
                          message: res.data.message,
                          type: 'error',
                        })
                        this.clickOver = true
                      }
                    }
                  )
                },
                res => {
                  this.$message.error(res.body.message)
                }
              )
            })
          }
        }
      })
    },

    handleSelect(item: Object) {
      // 选择小区信息
      this.form.blockName = item.value
      this.form.province = item.province
      this.form.city = item.city
      this.form.district = item.district
      this.form.blockId = item.pid
    },

    repQuerySearch(queryString, cb) {
      // 小管家信息
      let results = queryString
        ? this.repList.filter(
            item => item.value.indexOf(queryString.toLowerCase()) === 0
          )
        : this.repList
      cb(results)
    },

    repSelect(item) {
      // 选择小管家信息
      this.form.housekeeperPhone = item.phone
      this.form.housekeeperName = item.value
      this.form.housekeeperId = item.id
    },

    unitFormat(arr) {
      // 格式化片区列表
      // console.log(arr)
      for (let i = 0; i < arr.length; i++) {
        // arr[i].value = arr[i].text
        arr[i].value = arr[i].id
        arr[i].label = arr[i].text
        arr[i].cities = arr[i].children
        this.unitList.push(arr[i])
        if (
          arr[i].children !== null &&
          arr[i].children !== [] &&
          arr[i].children !== ''
        ) {
          this.unitFormat(arr[i].children)
        }
      }
      return arr
    },
    unitChange(value) {
      for (let i in this.unitList) {
        if (this.unitList[i].text === value[value.length - 1]) {
          this.form.zone = this.unitList[i].text
          this.form.zoneId = this.unitList[i].id
        }
      }
      console.log(this.form)
    },
    unitSearch(_this, value, arr) {
      for (let i in arr) {
        // console.log(arr[i].text, value)
        if (arr[i].text === value) {
          _this.form.zone = _this.unit[i].text
          _this.form.zoneId = _this.unit[i].id
        }
        if (
          arr[i].children !== null &&
          arr[i].children !== [] &&
          arr[i].children !== ''
        ) {
          _this.unitFormat(arr[i].children)
        }
      }
      return arr
    },

    changeRental(value) {
      this.form.deposit1 = value
    },

    handleProvinceDlgClose() {
      this.form.province = ''
      this.form.city = ''
      this.form.district = ''
    },

    // 选择省
    selectProvince(provinceId) {
      // 空置下级
      this.options.district = []
      this.form.city = ''
      this.form.district = ''
      if (provinceId) {
        API.fetchCities(provinceId).then(res => {
          if (res.data.code === 200) {
            this.options.city = res.data.data
          }
        })
      }
    },

    // 选择市
    selectCity(cityId) {
      // 空置下级
      this.form.district = ''
      if (cityId) {
        API.fetchDistrict(cityId).then(res => {
          if (res.data.code === 200) {
            this.options.district = res.data.data
          }
        })
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/forms/TrusteeshipForm/script.js